import hyphen from "../../../utils/hyphen";
import kitcut from "../../../utils/kitcut";

export const GameShopSlide = ({item, index, onClick}) => {
  return (
    <div className={'gifts__item gifts__item_' + index} onClick={onClick ?? void 0}>
      <div className="gifts__item_header">
        <div className="gifts__item_label">
          {
            item.showQuantity ? ((item.leftQuantity ?? 0) + '/' + (item.totalQuantity ?? 0)) : ''
          }
        </div>
        <div className="gifts__item_prices">
          <div className="gifts__item_prices_score">
            {
              ((typeof item.price === 'string' && item.price.length > 0) || (typeof item.price === 'number' && item.price > 0)) && (
                <>{item.price}</>)
            }
          </div>
          {
            ((typeof item.price === 'string' && item.price.length > 0) || (typeof item.price === 'number' && item.price > 0)) && (
              <div className="gifts__item_prices_svg"></div>)
          }
        </div>
      </div>
      <div className="gifts__item_img">
        {
          item.image && (<img src={item.image} alt="" title="" />)
        }
        {
          !item.image && (<div className="gifts__item_img_def"></div>)
        }
      </div>
      <div className="gifts__item_name"><span>{hyphen(kitcut(item.name, 35, true))}</span></div>
    </div>
  )

}